"use client";

import type { ReactNode } from "react";
import { HubbleProvider } from "@hubble/web";
import StyledComponentsRegistry from "./styled-components-registry";
import { StyledComponentsThemeProvider } from "./StyledComponentsThemeProvider";
import { ToasterProvider } from "./ToasterProvider";
import AppRouterCacheProvider from "./emotion-cache-provider";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <AppRouterCacheProvider options={{ enableCssLayer: false }}>
      <HubbleProvider locale={{}}>
        <StyledComponentsRegistry>
          <StyledComponentsThemeProvider>
            <ToasterProvider>{children}</ToasterProvider>
          </StyledComponentsThemeProvider>
        </StyledComponentsRegistry>
      </HubbleProvider>
    </AppRouterCacheProvider>
  );
}
